import { createContext } from "react";

const FormsContext = createContext();

export default FormsContext;
